import React from 'react';
import './instagramposts.css';

const InstagramPosts = ({ imageUrl, description, likes, comments, link }) => {
  return (
    <div className="instagram-post">
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={imageUrl} alt={description} className="instagram-image" />
    </a>
      <div className="instagram-description">
        <p>{description}</p>
        <div className="instagram-stats">
          <span>❤️ {likes}</span>
          <span>💬 {comments}</span>
        </div>
      </div>
    </div>
  );
}

export default InstagramPosts;